<template>
  <v-card class="fill-height">
    <v-card-title>
      <h3 class="headline font-weight-bold">{{getObjectValue('display_name', document)}}</h3>
      <v-spacer></v-spacer>
      <v-tooltip top v-if="onEditRoute">
        <v-btn icon flat slot="activator" to="edit" append>
          <div class="v-icon">
            <fa-icon :icon="['far', 'pencil-alt']" size="xs" />
          </div>
        </v-btn>
        <span>Edit</span>
      </v-tooltip>
      <v-tooltip top v-else>
        <v-btn icon flat slot="activator" @click="$router.back();" append>
          <div class="v-icon">
            <fa-icon :icon="['far', 'times']" size="xs" />
          </div>
        </v-btn>
        <span>Cancel</span>
      </v-tooltip>
    </v-card-title>

    <v-fade-transition mode="out-in" appear>
      <router-view :key="$route.fullPath" :document="document" v-if="document"></router-view>
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  props: {
    id: {
      default: null
    }
  },

  computed: {
    ...mapGetters("document_center", {
      SELECTED_DOCUMENT: "selectedDocument",
      DOCUMENTS: "documents"
    }),

    onEditRoute() {
      return this.$route.fullPath.indexOf("edit") === -1;
    },

    document() {
      if (!this.DOCUMENTS) {
        return null;
      }

      return this.SELECTED_DOCUMENT(this.id);
    }
  }
};
</script>
